/* External */
import { useMemo } from 'react';
import { useIntl } from 'react-intl';

/* Utils */
import {
  getFirstGenre,
  getFormattedDuration,
  useFullEpisodeName,
  getRating,
  isEpisode,
  isMovie,
  isShow,
  joinArrayWithSeparator,
  joinArrayWithSpace,
} from '../../utils/metaDataUtils';

export function useFeaturedCarouselSubtitle(content, isLive = false) {
  const { formatMessage } = useIntl();
  const fullEpisodeName = useFullEpisodeName(content);

  return useMemo(() => {
    if (isEpisode(content)) {
      return joinArrayWithSpace([
        getRating(content),
        fullEpisodeName,
      ]);
    }

    return joinArrayWithSpace([
      getRating(content),
      joinArrayWithSeparator([
        isShow(content) && formatMessage({ id: 'common.serie' }),
        !isLive && isMovie(content) && content?.releaseYear,
        getFirstGenre(content),
        !isLive && !isShow(content) && getFormattedDuration(content),
      ]),
    ]);
  }, [content, formatMessage, fullEpisodeName, isLive]);
}
